import * as React from 'react';
import { isBoolean, isNumber, isString } from 'lodash';
import { toJS } from 'mobx';
import * as draftToHtml from 'draftjs-to-html';
import { inject } from 'mobx-react';
import { IInjectedProps } from '../../interface/component/injected-props.interface';
import { renderDraftToHTML } from '../../util/draft/render-draft-to-html.util';
import { defaultFormatter, IDraftToHtmlProps } from '../draft-to-html/draft-to-html';

const style: React.CSSProperties = {
  width: '100%',
  wordWrap: 'break-word',
  wordBreak: 'break-word'
};

@inject('history', 'state')
export class EmailDraftToHtml extends React.Component<IDraftToHtmlProps & IInjectedProps> {
  render() {
    if (!this.props.draft || isString(this.props.draft) || isNumber(this.props.draft) || isBoolean(this.props.draft)) {
      return null;
    }
    const draftToJs = toJS(this.props.draft);
    const draftHtml = draftToHtml(draftToJs, undefined, undefined, renderDraftToHTML(this.props.state, Object.assign({}, defaultFormatter, this.props.mentionFormatter), this.props.inEditor, this.props.blockMentionData));
    return (
      <div
        style={style}
        dangerouslySetInnerHTML={{__html: draftHtml}}
      />
    );
  }
}
